import React from "react";
import { SHELL } from "@/api/connectorPackClient";

export default function ConnectorStatusCard({ connector, busy, onVerify, onDisable }) {
  const c = connector || {};
  const live = c.status === "LIVE_VERIFIED";
  const color = live ? "#7AC860" : c.status === "DISABLED" ? "#E5484D"
              : c.status === "NOT_CONFIGURED" ? "#E5A23A" : "#c5a059";
  return (
    <div style={SHELL.panel} data-testid={`connector-card-${c.name}`}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
        <h3 style={{ ...SHELL.h2, color: "#c5a059", textTransform: "none", letterSpacing: 0, fontSize: 15 }}>{c.name}</h3>
        <span style={SHELL.badge(color)}>{c.status}</span>
      </div>
      <div style={{ ...SHELL.dim, marginTop: 6 }}>
        Class: <strong>{c.class}</strong> · Credentials: <strong>{c.credential_class}</strong>
      </div>
      {(c.missing_env_keys || []).length > 0 && (
        <div style={{ ...SHELL.dim, marginTop: 6 }}>
          Missing: <span style={{ color: "#E5A23A" }}>{c.missing_env_keys.join(", ")}</span>
        </div>
      )}
      {c.compliance_flag && (
        <div style={{ ...SHELL.dim, marginTop: 6, color: "#E5A23A" }}>
          Compliance flag required (BAA/NEMT).
        </div>
      )}
      <div style={{ ...SHELL.dim, marginTop: 6 }}>{c.next_required_action}</div>
      <div style={{ marginTop: 10 }}>
        <button type="button" style={SHELL.btn(false)} onClick={onVerify} disabled={!!busy} data-testid={`connector-verify-${c.name}`}>
          {busy === "verify" ? "Verifying…" : "Verify"}
        </button>
        <button type="button" style={SHELL.btn(false)} onClick={onDisable} disabled={!!busy} data-testid={`connector-disable-${c.name}`}>
          {busy === "disable" ? "Disabling…" : "Disable"}
        </button>
      </div>
    </div>
  );
}
